import { CloudDownload, TrashCan } from '@livingdesign/icons';
import { IconButton } from '@livingdesign/react';
import React, { useState, useEffect } from 'react'
import { getMediaThumbnailValue, getThumbnailForMedia, splitFilename } from '../../../../../../utils/mediaUtil';
import { MEDIA_TYPE_FOR_MEDIA_THUMBNAIL } from '../../../../../../consts/MediaLibrary';
import { downloadAttachment } from '../../../../../../utils/blobStorage';

const QA_ID_PREFIX = "UploadedAttachmentListItem";

function UploadedAttachmentListItem({
    index,
    fileName,
    fileSource,
    removable,
    removeFileAtIndex,
    disbaled,
    id,
}) {

    const [fileType, setFileType] = useState(0);

    useEffect(() => {
        if(!fileName) return;
        const name = splitFilename(fileName);
        const extension = name.extension ? name.extension.toLowerCase() : "";
        setFileType(getMediaThumbnailValue(extension));        
    }, [fileName]);

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: "5px",
        }} data-testid={`${QA_ID_PREFIX}-container`}>
            <div data-testid={`${QA_ID_PREFIX}-thumbnail-container`}>
                <img
                    style={{
                        height: "30px",
                        width: "30px",
                    }}
                    id={`${id}-${QA_ID_PREFIX}-${index}-img`}
                    alt={fileName}
                    src={getThumbnailForMedia(fileType)}
                    data-testid={`${QA_ID_PREFIX}-thumbnail-image`}
                />
            </div>
            <div
                style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '450px',
                }}
                data-testid={`${QA_ID_PREFIX}-filename`}
            >{fileName}</div>
            <div>
            <IconButton
                a11yLabel='Download attachment'
                disabled={disbaled}
                onClick={() => downloadAttachment(fileSource, fileName)}
                data-testid={`${QA_ID_PREFIX}-download-button`}
            >
                <CloudDownload size="small" />
            </IconButton>
            {removable && <IconButton
                a11yLabel='delete-attachment'
                onClick={() => removeFileAtIndex(index)}
                disabled={disbaled}
                data-testid={`${QA_ID_PREFIX}-remove-button`}
            >
                <TrashCan size='small' />
            </IconButton>}
            </div>
        </div>
    )
}

export default UploadedAttachmentListItem;